import script from "./popup.vue?vue&type=script&setup=true&lang=js"
export * from "./popup.vue?vue&type=script&setup=true&lang=js"

import "./popup.vue?vue&type=style&index=0&id=75dc5ff8&lang=scss"

const __exports__ = script;

export default __exports__